import cn from "classnames";
import BookShow from "components/shared/book/show";
import Loader from "components/shared/loader";
import { organizationFlags, organizationFlagsEnum } from "helpers/enums";
import { paths } from "helpers/paths";
import { viewContainer } from "helpers/redux";
import { flagVal } from "helpers/system";
import React from "react";
import { NavLink, Redirect, Route, Switch } from "react-router-dom";
import UsersGroupForm from "../form";
import UsersGroupCars from "./cars";
import UsersGroupUsers from "./users";

class ShowCargoOwner extends BookShow {
    constructor(props) {
        super(props);
        const hiddenDirectionFlagVal = flagVal(organizationFlags, organizationFlagsEnum.HiddenDirection);
        this.hiddenDirection = (props.organization.intFlags & hiddenDirectionFlagVal) === hiddenDirectionFlagVal;
    }

    get dropdActions() {
        const actions = [
            { text: "Изменить", action: this.actionEdit },
            { text: "Удалить", action: this.actionClose },
        ];
        return actions;
    }

    actionEdit = () => {
        const { modal } = this.props;
        return modal({
            name: "default",
            windowMod: "wide",
            title: "Редактирование группы",
            CustomBody: UsersGroupForm,
            bodyData: {
                mergeParams: () => this.getItem(this.props),
                data: this.state.data,
                hiddenDirection: this.hiddenDirection,
            },
        });
    };

    renderBodyWrap = () => {
        const { isLoading } = this.state;
        if (isLoading) {
            return <Loader prefix="absolute-center" />;
        }
        return (
            <div className="d-flex flex-column h-100">
                <div className="container-fluid">
                    <div className="table-tabs m-0 mb-3">
                        <NavLink
                            to={paths.usersGroupUsers(this.state.data.id)}
                            className="table-tabs__item"
                            activeClassName="table-tabs__item--active"
                        >
                            Пользователи
                        </NavLink>
                        <NavLink
                            exact
                            to={paths.usersGroupCars(this.state.data.id)}
                            className="table-tabs__item"
                            activeClassName="table-tabs__item--active"
                        >
                            Машины
                        </NavLink>
                    </div>
                </div>
                <div className="flex-grow-1 overflow-hidden">
                    <Switch>
                        <Route path={paths.usersGroupUsers(":groupId")} component={UsersGroupUsers} />
                        <Route path={paths.usersGroupCars(":groupId")} component={UsersGroupCars} />
                        <Redirect to={paths.usersGroupUsers(this.state.data.id)} />
                    </Switch>
                </div>
            </div>
        );
    };

    renderHead = () => {
        const { back, title } = this.props;
        return (
            <div className="book-show__head">
                <div className="book-show__close close close--sm" onClick={back} />
                <div className="book-show__title">{this.state.data?.name || title}</div>
                {!!this.dropdActions.length && (
                    <div className="book-show__dropdown c-dropd">
                        <div className="c-dropd__btn" onClick={this.openDropd} />
                        {this.renderDropd()}
                    </div>
                )}
            </div>
        );
    };

    render() {
        const cname = cn("book-show__body", { "book-show__body--invalid": !this.state.isValid });
        return (
            <div className="page-col page-col--full mounted">
                <div className="page-book__show">
                    <div className="container-fluid">{this.renderHead()}</div>
                    <div className={cname}>{this.renderBodyWrap()}</div>
                </div>
            </div>
        );
    }
}

const ConfiguredShow = (props) => <ShowCargoOwner {...props} config={{}} initialState={{}} />;

export default viewContainer(ConfiguredShow, "users-groups");
